import React from 'react';
import { BaseLayout, type BaseLayoutConfig } from './BaseLayout';
import { DiligenciasManagerSidebar } from './DiligenciasManagerSidebar';

interface DiligenciasManagerLayoutProps {
  children: React.ReactNode;
}

export const DiligenciasManagerLayout: React.FC<DiligenciasManagerLayoutProps> = ({
  children,
}) => {
  const layoutConfig: BaseLayoutConfig = {
    headerVariant: 'full',
    headerTitle: 'Painel de Diligências',
    showNotifications: true,
    background: 'gray',
    bottomNavRole: 'admin',
  };

  return (
    <BaseLayout sidebar={<DiligenciasManagerSidebar />} config={layoutConfig}>
      {children}
    </BaseLayout>
  );
};
